import {connect} from 'react-redux'
import {selectScoreScreen, resetGrandmasterSession, changeViewing} from '../../../redux/modules/grandmaster'
import {toJS} from '../../../util/ToJS'
import ScoreScreen from '../components/ScoreScreen'

const mapStateToProps = state => {
  return selectScoreScreen(state)
}
const mapDispatchToProps = dispatch => ({
  continuePractice: () => dispatch(changeViewing('practice')),
  leavePractice: () => {
    dispatch(resetGrandmasterSession())
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(ScoreScreen))



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleScoreScreen.js